<template>
    <div class="content work_wrapper">
        <v-row class="search_box">
            <v-col>
                <searchBar></searchBar>
            </v-col>
        </v-row>
        <div class="report_center_wrapper">
            <div class="flex_style betw top_tips">
                <div class="md_title">分析报告</div>
            </div>
            <v-row>
                <v-col sm="12"
                       md="8">
                    <div class="flex_style  top_tips">
                        <div class="btn"
                             @click="goNew">
                            <v-icon color="#FFFFFF">mdi-plus</v-icon>
                            创建分析报告</div>
                    </div>
					</v-col>
					<v-col sm="12"
						md="3"
                       class="flex_style right">
                    <v-row class="flex_style left simple_searchTwo  top_tips">
                        <v-col xs="4"
                               sm="10"
                               class="input_box">
                            <v-text-field label=""
                                          v-model="keyWord"
                                          solo
                                          hide-details
                                          hide-selected></v-text-field>
                        </v-col>
                        <v-col xs="4"
                               sm="2"
                               class="right_btn hand"
                               @click="goResult">
                            <v-icon>mdi-magnify</v-icon>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col sm="12"
                       md="1">
                    <!-- <b class="line"></b> -->
                    <div class="flex_style left  top_tips">

                        <b style="width: 1px;
                    height: 16px;
                    border-radius: 6px;
                    background-color: #c9ced6;
                  "></b>
                        <div class="updown">
                            <v-btn v-if="sort == 'asc'"
                                   @click="sortChange('desc')">
                                <v-icon style="width:12px; height:12px;margin-left:15px;">mdi-arrow-up</v-icon>
                                <b class="test"> 时间降序</b>
                            </v-btn>
                            <v-btn v-if="sort == 'desc'"
                                   @click="sortChange('asc')">
                                <v-icon style="width:12px;height:12px;margin-left:5px;">mdi-arrow-down</v-icon>
                                <b class="test"> 时间升序</b>
                            </v-btn>
                        </div>
                    </div>
                </v-col>
            </v-row>
            <div class="reportList_wrapper"
                 v-if="list.length>0">
                <v-row>
                    <v-col sm="12"
                           md="4"
                           v-for="item in list"
                           :key="item.id"
                           class="item_wrapper">
                        <div class="item">
                            <v-row  >
                                <v-col sm="12"
                                       md="11">
                                    <div class="tit hand"
                                         @click="goReport(item.id,item.title)">{{item.title}}</div>
                                </v-col>
                                <v-col sm="12"
                                       md="1">
                                    <div class="more_btnfirst">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                        <div class="pop_center_wrapper table_type">
                                            <div class="list_item edit">
                                                <span class="icon"></span>
                                                <span class="text"
                                                      @click="editProjt(item)">编辑</span>
                                            </div>
                                            <div class="list_item del"
                                                 @click="delProject(item.id)">
                                                <span class="icon"></span>
                                                <span class="text">删除</span>
                                            </div>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>
                            <!--图表的统计数据-->
                            <div class="item_wrapper">
                                <div class="echarts">
                                </div>
                            </div>
                            <div class="actions">
                                <div class="time">
                                    <b>创建时间：</b>{{timeFormat(item.createdAt)}}</div>

                                <div class="more_btnTwo">
                                    <v-btn class="btn"
                                           @click="downLoad(item.id,item.title)">下载
                                        <v-icon>mdi-arrow-down</v-icon>
                                    </v-btn>
                                    <div class="pop_center_wrapper table_type">
                                        <div class="list_item del"
                                                     @click="reDownloadFile('2',item.id,item.title)">
                                                    <span class="icon"></span>
                                                    <span class="text">下载最新word</span>
                                                </div>
                                        <div class="list_item ppt">
                                            <span class="icon"></span>
                                            <span class="text"
                                                  @click="reDownloadFile('1',item.id,item.title)">下载最新pdf</span>
                                        </div>
                                        <div class="list_item"
                                             @click="oldHistory(item.id)">
                                            <span class="icon">
                                                <v-icon>mdi-file-document-outline</v-icon>
                                            </span>
                                            <span class="text">历史记录</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-col>
                </v-row>

            </div>
        </div>
        <v-dialog v-model="dialogWord"
                  height="282"
                  width="1100">
            <v-card>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="text_center">下载进度</div>
                    <v-row class="flex_style ">
                        <v-col>
                            <div v-if="progressNum<100">
                                <v-progress-linear v-model="progressNum"
                                                   color="#0095FF"
                                                   style="border-radius: 10px;"
                                                   height="20">
                                    <template v-slot:default="{ value }">
                                        <strong>{{ Math.ceil(value) }}%</strong>
                                    </template>
                                </v-progress-linear>
                            </div>
                            <div class="marg8">{{summary}}</div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="handleAddCancel">取消</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!---历史记录弹窗-->
        <v-dialog v-model="addVisible"
                  title=""
                  width="800px">
            <v-card>
                <v-card-title style="margin:0 auto;font-size: 18px;
                  padding:20px 20px;
                    font-weight: bold;
                    line-height: 24px;
                    color: #0D1A26;">历史下载记录
                    <span @click="addVisible = false">
                        <v-icon>mdi-close</v-icon>
                    </span>
                </v-card-title>
                <v-divider></v-divider>
                <!-- <v-data-table disable-pagination
                              :items="desserts"
                               hide-default-footer
                              :headers="headers"
                              :items-per-page="5"
                              class="elevation-1"> -->
                <v-data-table :items="reportList"
                              item-key="id"
                              v-model="createdAt"
                              :headers="headers"
                              :items-per-page="15"
                              hide-default-footer
                              disable-sort
                              class="common_table"
                              style="padding:20px 20px;">

                    <!-- <v-data-table @click:row="rowClick"
                                              item-key="companyName"
                                              single-select
                                              hide-default-footer
                                              :headers="headers1"
                                              :items="list1"
                                              :items-per-page="15"
                                              disable-sort
                                              class="common_table"> -->
                    <template v-slot:item.createdAt="{item}">
                        <div>
                            <span>{{timeFormat(item.createdAt)}}</span>
                        </div>
                    </template>
                    <template v-slot:item.type="{item}">
                        <div class="time">
                            <b v-if="item.type =='1'">Pdf</b>
                            <b v-if="item.type =='2'">Word</b>
                        </div>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <div v-if="item">
                            <v-btn style="
                                border: 1px solid #C9CED6;
                                line-height: 28px;
                                margin: 0;">
                                重新下载
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>
                <v-pagination v-model="currentPage"
                              :length="pageLength"
                              :total-visible="pageVisible">
                </v-pagination>
            </v-card>
        </v-dialog>
        <!--编辑-->
    </div>
</template>
<script>
import searchBar from '@/components/widgets/searchBar.vue'
import { mapActions } from 'vuex'
import echarts from 'echarts'
import qs from 'qs'

export default {
	data() {
		return {
			page: 1, //当前页面号
			pageLength: 0, //总页面数
			pageVisible: 7, //分页条中可见页面号数
			currentPage: 1,
			pageSize: 15,
			itemsPerPage: 15,
			// selectKeys: [],
			createdAt: '',
			formatKey: 0,
			reportId: '',
			pdfId: '',
			progressNum: 0, //下载
			summary: '',
			dialogWord: false,
			keyWord: '',
			list: [],
			reports: '',
			sort: 'desc',
			userInfo: {},
			// reportList: [],
			addVisible: false,
			editVisible: false,
			headers: [
				{
					text: '下载时间',
					align: 'start',
					sortable: false,
					value: 'createdAt'
				},
				{
					text: '文件类型',
					align: 'start',
					value: 'type'
				},
				{
					text: '操作',
					align: 'start',
					sortable: false,
					value: 'actions'
				}
			],
			reportList: [
				{
					createdAt: '',
					fileHref: '',
					id: '',
					percent: '',
					status: '',
					summary: '',
					type: '',
					updatedAt: ''
				}
			]
		}
	},
	watch: {
		currentPage(val) {
			// console.log('val----currentpage', val)
			this.oldHistory(this.reportId)
		}
	},
	created() {
		this.getList()
		// this.getFile() //下载的接口
		// this.oldHistory()
	},
	components: {
		searchBar
	},
	mounted() {
		this.getInfo()
		// this.getList()
	},
	methods: {
		...mapActions('report', [
			'getReportList',
			'downLoadFile',
			'getProgress',
			'reloadFile',
			'getDownLoadList',
			'deleteReport'
		]),
		...mapActions('user', ['personalInfo']),
		delProject(item){
			console.log(item)
			let _this =this;
			let params={
				reportID:item
			}
			this.deleteReport({
				data:params,
				handle(res){
					if(res.success){
						_this.getList()
					}
				}

			})
		},
		getInfo() {
			let _this = this
			let data = {
				params: {
					tag: 'user_info'
				}
			}
			this.personalInfo({
				data: data,
				handle(res) {
					let info = res.user
					_this.getList()
					_this.userInfo = info
					console.log('res', res)
				}
			})
		},
		timeFormat(unixTime) {
			let date = new Date(unixTime)
			let Y = date.getFullYear() + '-'
			let M =
				(date.getMonth() + 1 < 10
					? '0' + (date.getMonth() + 1)
					: date.getMonth() + 1) + '-'
			let D = date.getDate() + ' '
			let h = date.getHours() + ':'
			let m = date.getMinutes() + ':'
			let s = date.getSeconds()
			return Y + M + D + h + m + s
		},
		goResult() {
			this.getList()
		},
		goNew() {
			this.$router.push({
				path: '/report/new'
			})
		},
		editProjt() {
			this.editVisible = true
		},
		sortChange(val) {
			this.sort = val
			this.getList()
		},
		//下载的接口
		// downLoad(id, title) {
		// 	console.log('dddd', id)
		// 	this.reportId = id
		// 	console.log(this.reportId, '===this.reportId==')
		// 	// this.dialogWord = true
		// 	this.getFile()
		// },
		//下载的接口
		// getFile() {
		// 	let data = {
		// 		url: this.reportId,
		// 		data1: {
		// 			params: {
		// 				reportId: this.reportId,
		// 				type: ''
		// 			}
		// 		}
		// 	}
		// 	let _this = this
		// 	this.downLoadFile({
		// 		data: data,
		// 		handle(res) {
		// 			_this.pdfId = res.reportPdfId
		// 			if (res.reportPdfList.length > 0) {
		// 				_this.progressNum = res.reportPdfList[0].percent * 100
		// 			} else {
		// 				_this.progressNum = 0
		// 			}
		// 			_this.info = res.report
		// 			if (_this.progressNum < 100) {
		// 				_this.getPercent()
		// 			}
		// 		}
		// 	})
		// },
		//以上是下载的接口数据
		getList() {
			let data = {
				params: {
					searchWords: this.keyWord,
					sort: this.sort
				}
			}
			let _this = this
			this.getReportList({
				data: data,
				handle(res) {
					let list = res.reports
					// console.log(list, '===list===')
					if (_this.userInfo.id == '28776') {
						let arr = [656, 657, 575, 664]
						let newList = []
						list.forEach(element => {
							if (arr.indexOf(element.id) < 0) {
								newList.push(element)
							}
						})
						list = newList
					}
					_this.list = list
					_this.reportId = _this.userInfo.id
					//console.log(_this.reportId, '==== _this.reportId=====')
				}
			})
		},
		//重新下载
		// reDownloadFile(type) {
		// 	this.dialogWord = true
		// 	console.log('type', type)
		// 	let data = {
		//         reportId:this.reportId,
		// 		// url: this.reportId,
		// 		data1: {
		// 			params: {
		// 				type: type,
		//                 reportId:this.reportId,
		// 			}
		// 		}
		// 	}
		// reDownloadFile(id,title) {
		// 	this.dialogWord = true
		// 	console.log(id, '====id===')
        //     this.reportId = id
		// 	// console.log('type', type)
		// 	let data = {
		// 		reportId: this.id,
		// 		url: this.reportId,
		// 		data1: {
		// 			params: {
		// 				type: 2,
		// 				reportId: this.reportId
		// 			}
		// 		}
		// 	}
        reDownloadFile(type,id,title) {
			this.dialogWord = true
			console.log(id, '====id===')
            this.reportId = id
			// console.log('type', type)
			let data = {
				reportId: this.id,
				url: this.reportId,
				data1: {
					params: {
						type: type,
						reportId: this.reportId
					}
				}
			}
			let _this = this
			this.progressNum = 0
			this.reloadFile({
				data: data,
				handle(res) {
					if (res.success) {
						_this.pdfId = res.message
						if (type == '1') {
							_this.pdfInfoId = res.message
						} else {
							_this.wordInfoId = res.message
						}
						_this.getPercent()
					}
				}
			})
		},

		getPercent() {
			let data = {
				url: this.pdfId,
				data1: ''
			}
			let _this = this
			this.getProgress({
				data: data,
				handle(res) {
					if (res.success) {
						let info = JSON.parse(res.message)
						_this.progressNum = info.percent * 100
						_this.summary = info.summary
						if (_this.progressNum < 100) {
							_this.timer = setInterval(() => {
								_this.getProgress({
									data: data,
									handle(res) {
										if (res.success) {
											let info = JSON.parse(res.message)
											_this.progressNum =
												info.percent * 100
											_this.summary = info.summary
											if (_this.progressNum >= 100) {
												clearInterval(_this.timer)
												_this.reload()
												// window.open(path)
												_this.getList()
											}
										}
									}
								})
							}, 2000)
						}
					}
				}
			})
		},
		reload(val) {
			let id = ''
			if (val) {
				id = val == '1' ? this.pdfInfoId : this.wordInfoId
			} else {
				id = this.pdfId
			}
			let path = 'https://www.iprdb.com/report/' + id + '/load.html'
			let a = document.createElement('a')
			a.href = path
			a.click()
		},
		reload1(item) {
			let type = item.type
			if (type == '1' && this.pdfInfoId) {
				this.reload(type)
			} else if (type == '2' && this.wordInfoId) {
				this.reload(type)
			} else {
				let data = {
					url: this.reportId,
					data1: {
						params: {
							type: type
						}
					}
				}
				let _this = this
				this.reloadFile({
					data: data,
					handle(res) {
						if (res.success) {
							_this.pdfId = res.message
							if (type == '1') {
								_this.pdfInfoId = res.message
							} else {
								_this.wordInfoId = res.message
							}
							_this.reload(type)
						}
					}
				})
			}
		},
		//点击分页的功能
		// async onPageChange(page) {
		// 	this.page = page
		// 	await this.getList()
		// },
		//取消的按钮
		handleAddCancel() {
			//   this.form = {};
			this.dialogWord = false
		},
		//以上是下载的功能
		sendEmail(id, title) {
			this.$router.push({
				path: '/report/email/' + id,
				query: {
					title: title
				}
			})
		},

		newTword() {},
		//pdf
		newPdf() {},
		//历史记录
		oldHistory(id) {
			console.log('dddd---id', id)
			console.log(id, '===id==')
			this.addVisible = true
			this.reportId = id
			let data = {
				url: this.reportId,
				data1: {
					params: {
						reportId: this.reportId,
						page: this.currentPage,
						pageSize: this.pageSize
					}
				}
			}
			let _this = this
			this.getDownLoadList({
				data: data,
				handle(res) {
					_this.reportList = res.reportPdfList
					_this.pageLength = res.downloadCount
					console.log(_this.pageLength, '===_this.pageLength==')
				}
			})
		},
		goReport(id, title) {
			this.$router.push({
				path: '/report/' + id,
				query: {
					title: title
				}
			})
		}
	}
}
</script>